export default function StoryCarouselItemSkeleton() {
  return (
    <div className="flex flex-col items-center gap-4 w-28 flex-shrink-0 animate-pulse">
      <div className="relative">
        <div className="w-20 h-20 rounded-full bg-gray-200" />
        <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 h-4 w-10 bg-gray-200 rounded-md" />
      </div>
      <div className="h-4 w-20 bg-gray-200 rounded" />
      <div className="flex gap-1">
        <div className="h-7 w-7 bg-gray-200 rounded-sm" />
        <div className="h-7 w-7 bg-gray-200 rounded-sm" />
      </div>
    </div>
  );
};